
// Definición de defaults

export const defaultTipoTramite: TipoTramiteProps = {
    idTipoTramite:  0,
    descripcion:    '',
    activo:         false,
};

// Creación de interfaces

export interface TipoTramiteProps{
    idTipoTramite:  number;
    descripcion:    string;
    activo:         boolean;
}
